import { ExpectedError } from "../../expectedError";

const DB2_PASSWORD_PLACEHOLDER = "__TINES_DB2_PASSWORD__";

function validateHost(host: string | undefined) {
  const value = (host ?? "").trim();
  if (!/^[A-Za-z0-9.-]+$/.test(value)) {
    throw new ExpectedError("Invalid IBM Db2 for i host");
  }
  return value;
}

function validatePort(port: string | undefined) {
  const value = (port ?? "").trim();
  if (!/^\d+$/.test(value)) {
    throw new ExpectedError("Invalid IBM Db2 for i port");
  }
  const number = Number(value);
  if (number < 1 || number > 65535) {
    throw new ExpectedError("Invalid IBM Db2 for i port");
  }
  return value;
}

function validateKeywordValue(
  value: string | undefined,
  label: "database" | "username"
) {
  const trimmed = (value ?? "").trim();
  if (!trimmed || /[;='"]/.test(trimmed)) {
    throw new ExpectedError(`Invalid IBM Db2 for i ${label}`);
  }
  return trimmed;
}

export function ibmDb2ForIConnectionString({
  host,
  port,
  database,
  username,
  tls,
}: Record<string, string>) {
  const keywords = [
    `DATABASE=${validateKeywordValue(database, "database")}`,
    `HOSTNAME=${validateHost(host)}`,
    `PORT=${validatePort(port)}`,
    "PROTOCOL=TCPIP",
    `UID=${validateKeywordValue(username, "username")}`,
    `PWD=${DB2_PASSWORD_PLACEHOLDER}`,
    "AUTHENTICATION=SERVER",
    "CONNECTTIMEOUT=10",
  ];
  if (tls === "true") {
    keywords.push(
      "SECURITY=SSL",
      "SSLServerCertificate=/etc/ssl/certs/ca-certificates.crt"
    );
  }
  return `${keywords.join(";")};`;
}
